import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { CartProvider } from "./context/CartContext.jsx";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Signup from "./pages/Signup";

import { Toaster } from "react-hot-toast";

import "./index.css";

function App() {

  return (

    <ThemeProvider>

      <AuthProvider>

        <CartProvider>

          <Router>

            <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900 text-gray-900 dark:text-white">

              {/* Navbar */}

              <Navbar />

              {/* Main Content */}

              <main className="flex-grow pt-24">

                <Routes>

                  <Route path="/" element={<Home />} />

                  <Route path="/shop" element={<Shop />} />

                  <Route
                    path="/product/:id"
                    element={<ProductDetail />}
                  />

                  <Route path="/cart" element={<Cart />} />

                  <Route path="/checkout" element={<Checkout />} />

                  <Route path="/admin" element={<Admin />} />

                  <Route path="/login" element={<Login />} />

                  <Route path="/signup" element={<Signup />} />

                </Routes>

              </main>

              {/* Footer */}

              <Footer />

            </div>

          </Router>

          {/* Toast Notifications */}

          <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                background: "#111",
                color: "#fff",
                border: "1px solid #333"
              }
            }}
          />

        </CartProvider>

      </AuthProvider>

    </ThemeProvider>

  );

}

export default App;